import { TypographyVariants } from 'ThemeV2.0';

export const getCheckboxLabelTypography = (checked: boolean) => ({
  variant: (checked ? 'body2' : 'body3') as TypographyVariants,
  sx: checked ? undefined : { fontWeight: 600 },
});
